export interface IMulticastChannelDefinition {
  Ip: string;
  Port: number;
  Sid: number;
}

export const MULTICAST_TYPE = {
  SD: 'sd',
  HD: 'hd',
  UHD: 'uhd',
  UHDHDR: 'uhdhdr',
} as const;

export type TMulticastTypes =
  (typeof MULTICAST_TYPE)[keyof typeof MULTICAST_TYPE];

export type TMulticastLoadVideoOptions = {
  [key in TMulticastTypes]?: IMulticastChannelDefinition;
};
